module.exports={
    "expenses_addExpense": {
        "id": "expenses_addExpense",
        "eventName": "adicionar_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Despesas",
        "eventValue": 0
    },
    "expenses_addRoute": {
        "id": "expenses_addRoute",
        "eventName": "adicionar_percurso",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Despesas",
        "eventValue": 0
    },
    "expenses_addRouteByMap": {
        "id": "expenses_addRouteByMap",
        "eventName": "adicionar_percurso_mapa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Despesas",
        "eventValue": 0
    },
    "expenses_insertInReport": {
        "id": "expenses_insertInReport",
        "eventName": "adicionar_relatorio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Despesas",
        "eventValue": 0
    },
    "-expenses_expenseReport": {
        "id": "-expenses_expenseReport",
        "eventName": "Selecionar_relatorio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Despesas | Modal para adicionar relatório",
        "eventValue": 0
    },
    "-expenses_saveReport": {
        "id": "-expenses_saveReport",
        "eventName": "salvar_despesas_ relatorio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Despesas | Modal para adicionar relatório",
        "eventValue": 0
    },
    "-expenses_cancelReport": {
        "id": "-expenses_cancelReport",
        "eventName": "cancelar _adicionar_despesas_relatorio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Despesas | Modal para adicionar relatório",
        "eventValue": 0
    },
    "expenses_deleteExpense": {
        "id": "expenses_deleteExpense",
        "eventName": "deletar_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Aba da despesa",
        "eventValue": 0
    },
    "-expenses_confirmDeleteExpense": {
        "id": "-expenses_confirmDeleteExpense",
        "eventName": "confirmar_deletar_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Despesas | Modal de deletar despesa",
        "eventValue": 0
    },
    "expenses_searchFilter": {
        "id": "expenses_searchFilter",
        "eventName": "pesquisar_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral despesas",
        "eventValue": 0
    },
    "expenses_dateStartFilter": {
        "id": "expenses_dateStartFilter",
        "eventName": "data_inicio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral despesas",
        "eventValue": 0
    },
    "expenses_dateEndFilter": {
        "id": "expenses_dateEndFilter",
        "eventName": "data_fim",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral despesas",
        "eventValue": 0
    },
    "expenses_typeFilter": {
        "id": "expenses_typeFilter",
        "eventName": "tipo",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral despesas",
        "eventValue": "{{label}}"
    },
    "expenses_paymentFilter": {
        "id": "expenses_paymentFilter",
        "eventName": "forma_pagamento",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral despesas",
        "eventValue": "{{label}}"
    },
    "expenses_checkboxTable": {
        "id": "expenses_checkboxTable",
        "eventName": "deselect_todos_despesas",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas | filtro",
        "eventValue": 0
    },
    "expenses_dateTable": {
        "id": "expenses_dateTable",
        "eventName": "data",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas | filtro",
        "eventValue": 0
    },
    "expenses_titleTable": {
        "id": "expenses_titleTable",
        "eventName": "título",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas | filtro",
        "eventValue": 0
    },
    "expenses_typeTable": {
        "id": "expenses_typeTable",
        "eventName": "tipo",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas | filtro",
        "eventValue": 0
    },
    "expenses_reportTable": {
        "id": "expenses_reportTable",
        "eventName": "relatorio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas | filtro",
        "eventValue": 0
    },
    "expenses_statusTable": {
        "id": "expenses_statusTable",
        "eventName": "status",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas | filtro",
        "eventValue": 0
    },
    "expenses_amountTable": {
        "id": "expenses_amountTable",
        "eventName": "valor",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas | filtro",
        "eventValue": 0
    },
    "expenses_checkboxItemTable": {
        "id": "expenses_checkboxItemTable",
        "eventName": "select_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas",
        "eventValue": 0
    },
    "expenses_deleteItemTable": {
        "id": "expenses_deleteItemTable",
        "eventName": "deletar_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas",
        "eventValue": 0
    },
    "-expenses_confirmDeleteExpenseItem": {
        "id": "-expenses_confirmDeleteExpenseItem",
        "eventName": "confirmar_deletar_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Aba da despesa",
        "eventValue": 0
    },
    "-expenses_cancelDeleteExpenseItem": {
        "id": "-expenses_cancelDeleteExpenseItem",
        "eventName": "cancelar_deletar_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Aba da despesa",
        "eventValue": 0
    },
    "expenses_allExpensesFilter": {
        "id": "expenses_allExpensesFilter",
        "eventName": "todas_despesas",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral despesas",
        "eventValue": 0
    },
    "expenses_singleExpenseFilter": {
        "id": "expenses_singleExpenseFilter",
        "eventName": "somente_avulsas",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral despesas",
        "eventValue": 0
    },
    "expenses_refundableFilter": {
        "id": "expenses_refundableFilter",
        "eventName": "reembolsavel",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral despesas",
        "eventValue": 0
    },
    "expenses_notRefundableFilter": {
        "id": "expenses_notRefundableFilter",
        "eventName": "nao_reembolsavel",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral despesas",
        "eventValue": 0
    },
    "expenses_expensesClickTable": {
        "id": "expenses_expensesClickTable",
        "eventName": "click_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas",
        "eventValue": 0
    },
    "despesa_addAttachment": {
        "id": "despesa_addAttachment",
        "eventName": "anexar_documento",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_description": {
        "id": "expensesModal_description",
        "eventName": "descricao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_coin": {
        "id": "expensesModal_coin",
        "eventName": "moeda",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": "{{label}}"
    },
    "expensesModal_value": {
        "id": "expensesModal_value",
        "eventName": "valor",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": "{{label}}"
    },
    "expensesModal_type": {
        "id": "expensesModal_type",
        "eventName": "tipo",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": "{{label}}"
    },
    "expensesModal_date": {
        "id": "expensesModal_date",
        "eventName": "data",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_report": {
        "id": "expensesModal_report",
        "eventName": "nome_relatorio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_costCenter": {
        "id": "expensesModal_costCenter",
        "eventName": "centro_custos",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_payment": {
        "id": "expensesModal_payment",
        "eventName": "forma_pagamento",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": "{{label}}"
    },
    "expensesModal_refundable": {
        "id": "expensesModal_refundable",
        "eventName": "checkbox_reembolsavel",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_observation": {
        "id": "expensesModal_observation",
        "eventName": "observacao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_obsAttachments": {
        "id": "expensesModal_obsAttachments",
        "eventName": "adicionar_anexo_observacao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "-expensesModal_removeObsAttachments": {
        "id": "-expensesModal_removeObsAttachments",
        "eventName": "retirar_anexo_observacao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_project": {
        "id": "expensesModal_project",
        "eventName": "projeto",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_close": {
        "id": "expensesModal_close",
        "eventName": "fechar_modal_x",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_closeButton": {
        "id": "expensesModal_closeButton",
        "eventName": "fechar_modal_botao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_save": {
        "id": "expensesModal_save",
        "eventName": "salvar_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_addRateio": {
        "id": "expensesModal_addRateio",
        "eventName": "adicionar_projeto_rateio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "-expensesModal_removeRateio": {
        "id": "-expensesModal_removeRateio",
        "eventName": "retirar_projeto_rateio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Rateio",
        "eventValue": 0
    },
    "-expensesModal_percentageRateio": {
        "id": "-expensesModal_percentageRateio",
        "eventName": "porcentagem_rateio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Rateio",
        "eventValue": 0
    },
    "-expenses_projectRateio": {
        "id": "-expenses_projectRateio",
        "eventName": "projeto_rateio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Rateio",
        "eventValue": 0
    },
    "despesa_addAttachmentError": {
        "id": "despesa_addAttachmentError",
        "eventName": "anexar_documento_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_descriptionError": {
        "id": "expensesModal_descriptionError",
        "eventName": "descricao_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_coinError": {
        "id": "expensesModal_coinError",
        "eventName": "moeda_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": "{{label}}"
    },
    "expensesModal_valueError": {
        "id": "expensesModal_valueError",
        "eventName": "valor_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": "{{label}}"
    },
    "expensesModal_typeError": {
        "id": "expensesModal_typeError",
        "eventName": "tipo_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": "{{label}}"
    },
    "expensesModal_dateError": {
        "id": "expensesModal_dateError",
        "eventName": "data_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_reportError": {
        "id": "expensesModal_reportError",
        "eventName": "relatorio_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_costCenterError": {
        "id": "expensesModal_costCenterError",
        "eventName": "centro_custos_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": "{{label}}"
    },
    "expensesModal_paymentError": {
        "id": "expensesModal_paymentError",
        "eventName": "forma_pagamento_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": "{{label}}"
    },
    "expensesModal_refundableError": {
        "id": "expensesModal_refundableError",
        "eventName": "checkbox_reembolsavel_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_observationError": {
        "id": "expensesModal_observationError",
        "eventName": "observacao_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_attachmentsError": {
        "id": "expensesModal_attachmentsError",
        "eventName": "anexo_observacao_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_obsAttachmentsError": {
        "id": "expensesModal_obsAttachmentsError",
        "eventName": "anexo_observacao_erro_limite",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModal_saveError": {
        "id": "expensesModal_saveError",
        "eventName": "salvar_despesa_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "despesa_removeAttachment": {
        "id": "despesa_removeAttachment",
        "eventName": "retirar_anexo_documento",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de despesa | Principal",
        "eventValue": 0
    },
    "expensesModalRoute_routes": {
        "id": "expensesModalRoute_routes",
        "eventName": "trechos_pre_cadastrados",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_description": {
        "id": "expensesModalRoute_description",
        "eventName": "descricao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_kilometer": {
        "id": "expensesModalRoute_kilometer",
        "eventName": "quilometragem",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_coin": {
        "id": "expensesModalRoute_coin",
        "eventName": "moeda",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": "{{label}}"
    },
    "expensesModalRoute_payedKilomeeter": {
        "id": "expensesModalRoute_payedKilomeeter",
        "eventName": "valor_km",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_date": {
        "id": "expensesModalRoute_date",
        "eventName": "data",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_report": {
        "id": "expensesModalRoute_report",
        "eventName": "relatorio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_costCenter": {
        "id": "expensesModalRoute_costCenter",
        "eventName": "centro_custos",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_payment": {
        "id": "expensesModalRoute_payment",
        "eventName": "forma_pagamento",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": "{{label}}"
    },
    "expensesModalRoute_refundable": {
        "id": "expensesModalRoute_refundable",
        "eventName": "checkbox_reembolsavel",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_observation": {
        "id": "expensesModalRoute_observation",
        "eventName": "observacao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_close": {
        "id": "expensesModalRoute_close",
        "eventName": "fechar_modal_botao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_save": {
        "id": "expensesModalRoute_save",
        "eventName": "salvar_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_addRateio": {
        "id": "expensesModalRoute_addRateio",
        "eventName": "adicionar_projeto_rateio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "-expensesModalRoute_remove_rateio": {
        "id": "-expensesModalRoute_remove_rateio",
        "eventName": "retirar_projeto_rateio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "-expensesModalRoute_percentage": {
        "id": "-expensesModalRoute_percentage",
        "eventName": "porcentagem_rateio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "-expensesModalRoute_projectRateio": {
        "id": "-expensesModalRoute_projectRateio",
        "eventName": "projeto_rateio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_removeAttachment": {
        "id": "expensesModalRoute_removeAttachment",
        "eventName": "retirar_anexo_documento",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "percurso_addAttachmentError": {
        "id": "percurso_addAttachmentError",
        "eventName": "anexar_documento_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_routesError": {
        "id": "expensesModalRoute_routesError",
        "eventName": "trechos_pre_cadastrados_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_descriptionError": {
        "id": "expensesModalRoute_descriptionError",
        "eventName": "valor_km_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_kilometerError": {
        "id": "expensesModalRoute_kilometerError",
        "eventName": "descricao_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_payedKilomeeterError": {
        "id": "expensesModalRoute_payedKilomeeterError",
        "eventName": "quilometragem_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_coinError": {
        "id": "expensesModalRoute_coinError",
        "eventName": "moeda_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_dateError": {
        "id": "expensesModalRoute_dateError",
        "eventName": "data_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_reportError": {
        "id": "expensesModalRoute_reportError",
        "eventName": "relatorio_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_costCenterError": {
        "id": "expensesModalRoute_costCenterError",
        "eventName": "centro_custos_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": "{{label}}"
    },
    "expensesModalRoute_paymentError": {
        "id": "expensesModalRoute_paymentError",
        "eventName": "forma_pagamento_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": "{{label}}"
    },
    "expensesModalRoute_refundableError": {
        "id": "expensesModalRoute_refundableError",
        "eventName": "observacao_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalRoute_saveError": {
        "id": "expensesModalRoute_saveError",
        "eventName": "salvar_despesa_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso manual",
        "eventValue": 0
    },
    "expensesModalMap_addRoute": {
        "id": "expensesModalMap_addRoute",
        "eventName": "adicionar_caminho",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Mapa",
        "eventValue": 0
    },
    "expensesModalMap_close": {
        "id": "expensesModalMap_close",
        "eventName": "fechar_modal_botao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_nextStep": {
        "id": "expensesModalMap_nextStep",
        "eventName": "proxima_etapa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Mapa",
        "eventValue": 0
    },
    "expensesModalMap_description": {
        "id": "expensesModalMap_description",
        "eventName": "descricao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_kilometer": {
        "id": "expensesModalMap_kilometer",
        "eventName": "quilometrragem",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_coin": {
        "id": "expensesModalMap_coin",
        "eventName": "moeda",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": "{{label}}"
    },
    "expensesModalMap_paymentKilometer": {
        "id": "expensesModalMap_paymentKilometer",
        "eventName": "valor_km",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_date": {
        "id": "expensesModalMap_date",
        "eventName": "data",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_report": {
        "id": "expensesModalMap_report",
        "eventName": "relatorio",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_costCenter": {
        "id": "expensesModalMap_costCenter",
        "eventName": "centro_custos",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_payment": {
        "id": "expensesModalMap_payment",
        "eventName": "forma_pagamento",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": "{{label}}"
    },
    "expensesModalMap_refundable": {
        "id": "expensesModalMap_refundable",
        "eventName": "checkbox_reembolsavel",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_observation": {
        "id": "expensesModalMap_observation",
        "eventName": "observacao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "-expensesModalMap_project": {
        "id": "-expensesModalMap_project",
        "eventName": "projeto",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_save": {
        "id": "expensesModalMap_save",
        "eventName": "salvar_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_previousStep": {
        "id": "expensesModalMap_previousStep",
        "eventName": "voltar_etapa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_descriptionError": {
        "id": "expensesModalMap_descriptionError",
        "eventName": "descricao_error",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_kilometerError": {
        "id": "expensesModalMap_kilometerError",
        "eventName": "quilometragem_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_coinError": {
        "id": "expensesModalMap_coinError",
        "eventName": "moeda_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": "{{label}}"
    },
    "expensesModalMap_paymentKilometerError": {
        "id": "expensesModalMap_paymentKilometerError",
        "eventName": "valor_km_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_dateError": {
        "id": "expensesModalMap_dateError",
        "eventName": "data_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_reportError": {
        "id": "expensesModalMap_reportError",
        "eventName": "relatorio_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_costCenterError": {
        "id": "expensesModalMap_costCenterError",
        "eventName": "centro_custos_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": "{{label}}"
    },
    "expensesModalMap_paymentError": {
        "id": "expensesModalMap_paymentError",
        "eventName": "forma_pagamento_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": "{{label}}"
    },
    "expensesModalMap_observationError": {
        "id": "expensesModalMap_observationError",
        "eventName": "observacao_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "expensesModalMap_saveError": {
        "id": "expensesModalMap_saveError",
        "eventName": "salvar_despesa_erro",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Informações adicionais",
        "eventValue": 0
    },
    "-expensesModalMap_removePath": {
        "id": "-expensesModalMap_removePath",
        "eventName": "retirar_caminho",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Modal de cadastro de percurso por mapa | Mapa",
        "eventValue": 0
    },
    "expenses_zoomImage": {
        "id": "expenses_zoomImage",
        "eventName": "abrir_imagem",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Aba da despesa",
        "eventValue": 0
    },
    "expenses_editExpense": {
        "id": "expenses_editExpense",
        "eventName": "editar_despesa",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Aba da despesa",
        "eventValue": 0
    },
    "expenses_attachment": {
        "id": "expenses_attachment",
        "eventName": "anexo_observacao",
        "eventProduct": "despesas",
        "eventCategory": "prestação de contas",
        "eventAction": "Aba da despesa",
        "eventValue": 0
    },
    "-expenses_redesignButton": {
        "id": "-expenses_redesignButton",
        "eventName": "voltar_para_versao_atual",
        "eventProduct": "despesas",
        "eventCategory": "Voltar para versão atual",
        "eventAction": "Voltar para versão atual",
        "eventValue": 0
    }
}
